<template>
  <span>
    <input class="jps-input" type="date" v-model="innerValue" />
    <span v-show="invalid">日付の形式が無効です</span>
  </span>
</template>

<script lang="ts" setup>
interface Props {
  modelValue?: number
}
const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits(['update:modelValue'])

const invalid: Ref<boolean> = ref(false)

const innerValue = computed({
  get: () => {
    if (props.modelValue != null) {
      return formatDate(new Date(props.modelValue), 'yyyy-MM-dd')
    } else {
      return null
    }
  },
  set: v => {
    if (typeof v === 'string') {
      const d = new Date(v)
      if (d.toString() === 'Invalid Date') {
        invalid.value = true
      } else {
        emit('update:modelValue', d.getTime())
        invalid.value = false
      }
    } else {
      invalid.value = true
    }
  },
})
</script>

<style lang="scss" scoped></style>
